import { createReducer } from '@reduxjs/toolkit';
import { setVehicleTypes } from '../../actions/types';

export const initialState = window.ecom.redux_initial_state.types || {};

const TypesReducer = createReducer(initialState, {
  [setVehicleTypes]: (state, action) => {
    state.vehicleTypes = action.payload;
  },
});

export default TypesReducer;
